module.exports = __webpack_public_path__ + "static/media/image4.59f3ce8d.JPG";